import axios from "axios";
import { BaseApiUrl } from "@/globals"

export default {
	namespaced: true,
	state: {
		listaDeVendas: []
	},
	getters: {

		getListaDeVendas(state) {
			return state.listaDeVendas
		}
	},
	mutations: {

		setListaDeVendas(state, payload) {
			state.listaDeVendas = payload
		}
	},
	actions: {
		
		getListaDeVendas: (context) => {
			axios(`${ BaseApiUrl }/vendas`)
			.then(vendas => {
				context.commit("setListaDeVendas",vendas.data);
			})
		},
	}
};
